import { gql } from '@apollo/client';

export const GET_NOTIFICATION_PREFERENCES = gql`
  query GetNotificationPreferences {
    user {
      _id
      notificationPreferences {
        postExpiringWarning
        postExpiredNotice
        marketing
      }
    }
  }
`;

export const GET_USER_POSTS = gql`
  query GetUserPosts {
    getUserPosts {
      _id
      type
      postType
      title
      description
      createdAt

      expiresAt
      extensionCount
      lastExtendedAt

      animalName
      animalType
      breed
      colorMarkings
      dateLost
      dateFound
      animalImageUrl
      imageUrl
      contactName
      contactEmail
      contactPhone
      rewardAmount
      sex
      lastSeen
      foundNear
      estimatedWeight
      approachable
      reunited
      language
    }
  }
`;
